import { writable, get } from 'svelte/store';

const isDrawStrokeDashFrameDefault = false;
const isDrawStrokeDashDefault = false;
const drawStrokeDashFrameDefault = [5, 10, 0, 0, 0, 0, 0, 0];
const drawStrokeDashDefault = [5, 10, 0, 0, 0, 0, 0, 0];
const drawWidthDefault = 1;
const drawShadowYDefault = 0;
const drawShadowXDefault = 0;
const drawShadowBlurDefault = 0;
const drawOpacityDefault = 1;
const drawOpacityStrokeDefault = 1;
const drawColorDefault = '#333';
const drawStrokeColorDefault = '#333';
const drawStrokeColorFrameDefault = '#333';
const drawShadowColorDefault = '#333';
const effectColorDefault = '#333';
const drawStrokeLineCapDefault = 'round';
const drawStrokeLineCapFrameDefault = 'round';
const isShadowDefault = false;
const isPatternDefault = false;
const isScaleStrokeDefault = false;
const typeShapeDefault = 'line';
const typeBrushDefault = 'Pencil';
const drawFontSizeDefault = 30;
const drawFontFamilyDefault = 'Arial';
const drawTextAlignDefault = 'left';
const drawTextLineHeightDefault = 'left';
const drawTextFontWeightDefault = '';
const drawTextLineDefault = '---';
const drawTextStyleDefault = '---';

const overlayOpacityDefault = 1;

const isEnabledFrameDefault = false;
const radioGroupTimeDefault = 'dateTime';
const frameWidthDefault = 20;
const frameOpacityDefault = 0;

const _store = writable({
  iDCount: 1,
  currentFill: 'color',
  currentStroke: 'color',
  frameOpacity: frameOpacityDefault,
  frameWidth: frameWidthDefault,
  radioGroupTime: radioGroupTimeDefault,
  isEnabledFrame: isEnabledFrameDefault,
  isMenuLayer: false,
  isCustomAnimation: false,
  drawBrushRandomColor: false,
  isMenuAnimation: false,
  isMenuDraw: false,
  isMenuSound: false,
  isMenuOverlay: false,
  isWindowShapeFill: false,
  mainOverlayIsPlaing: false,
  effectColor: effectColorDefault,
  overlay: null,
  drawTextFontWeight: drawTextFontWeightDefault,
  drawTextLineHeight: drawTextLineHeightDefault,
  drawTextLine: drawTextLineDefault,
  drawFontSize: drawFontSizeDefault,
  drawFontFamily: drawFontFamilyDefault,
  drawTextAlign: drawTextAlignDefault,
  drawTextLine: drawTextLineDefault,
  drawTextStyle: drawTextStyleDefault,
  typeBrush: typeBrushDefault,
  strokeGradient: null,
  strokeGradientFrame: null,
  fillGradient: null,
  fillGradientFrame: null,
  popoverMode: '',
  isScaleStroke: isScaleStrokeDefault,
  isDrawStrokeDash: isDrawStrokeDashDefault,
  isDrawStrokeDashFrame: isDrawStrokeDashFrameDefault,
  drawStrokeDash: drawStrokeDashDefault,
  drawStrokeDashFrame: drawStrokeDashFrameDefault,
  typeShape: typeShapeDefault,
  opacityImage: 1,
  drawWidth: drawWidthDefault,
  overlayOpacity: overlayOpacityDefault,
  drawShadowY: drawShadowYDefault,
  drawShadowX: drawShadowXDefault,
  drawShadowBlur: drawShadowBlurDefault,
  drawOpacity: drawOpacityDefault,
  drawOpacityStroke: drawOpacityStrokeDefault,
  drawColor: drawColorDefault,
  drawStrokeColor: drawStrokeColorDefault,
  drawStrokeColorFrame: drawStrokeColorFrameDefault,
  drawShadowColor: drawShadowColorDefault,
  drawStrokeLineCap: drawStrokeLineCapDefault,
  drawStrokeLineCapFrame: drawStrokeLineCapFrameDefault,
  isDraw: false,
  isShadow: isShadowDefault,
  isPattern: isPatternDefault,
  isEdit: true,
  strokePatternFrame: { src: '', name: '' },
  strokePattern: { src: '', name: '' },
  fillPattern: { src: '', name: '' },
  fillPatternFrame: { src: '', name: '' },
  opacityImageOverlay: 1,
});

const store = {
  getStore() {
    return get(_store);
  },
  trigger() {
    _store.update((s) => {
      const newStore = { ...s };
      return newStore;
    });
  },
  setValueToggle(name) {
    const oldValue = this.getStore()[name];
    _store.update((s) => {
      const newStore = { ...s, [name]: !oldValue };
      return newStore;
    });
  },
  getDrawStrokeColor() {
    return getStore().drawStrokeColor;
  },
  getDrawShadowColor() {
    return getStore().drawShadowColor;
  },
  subscribe: _store.subscribe,

  setValue(name, value) {
    _store.update((s) => {
      const newStore = { ...s, [name]: value };
      return newStore;
    });
  },
  setValues(values) {
    _store.update((s) => {
      const newStore = { ...s, ...values };
      return newStore;
    });
  },
  setType(type) {
    _store.update((s) => {
      const newStore = { ...s, type };
      return newStore;
    });
  },
  setIsDraw(isDraw) {
    _store.update((s) => {
      const newStore = { ...s, isDraw };
      return newStore;
    });
  },
  setIsEdit(isEdit) {
    _store.update((s) => {
      const newStore = { ...s, isEdit };
      return newStore;
    });
  },
  setDrawDefault() {
    _store.update((s) => {
      const newStore = {
        ...s,
        ...{
          typeBrush: typeBrushDefault,
          drawWidth: drawWidthDefault,
          drawShadowY: drawShadowYDefault,
          drawShadowX: drawShadowXDefault,
          drawShadowBlur: drawShadowBlurDefault,
          drawOpacity: drawOpacityDefault,
          drawOpacityStroke: drawOpacityStrokeDefault,
          drawColor: drawColorDefault,
          drawStrokeColor: drawStrokeColorDefault,
          drawShadowColor: drawShadowColorDefault,
          drawStrokeLineCap: drawStrokeLineCapDefault,
          isShadow: isShadowDefault,
          isPattern: isPatternDefault,
          typeShape: typeShapeDefault,
          isDrawStrokeDash: isDrawStrokeDashDefault,
          drawStrokeDash: drawStrokeDashDefault,
          isScaleStroke: isScaleStrokeDefault,
          strokePattern: '',
          fillPattern: '',
          strokeGradient: null,
          fillGradient: null,
        },
      };
      return newStore;
    });
  },
  toggleIsEdit() {
    _store.update((s) => {
      const newStore = { ...s, isEdit: !s.isEdit };
      return newStore;
    });
  },
};

export default store;
